import { processTankData, addPharmaSumFormulas } from './tankDataUtils';

export const generatePharmaSheet = async (ws, lastOps, tankDataMap, volumeUnit, cellarsRef, tankMapping) => {
  const boldStyle = { font: { bold: true, name: 'Arial' } };
  const boldCenteredStyle = { 
    font: { bold: true, name: 'Arial' },
    alignment: { horizontal: 'center', vertical: 'middle' },
  };

  // Define constants for row indexing
  const HEADER_ROWS = 4;
  const TANK_DATA_START_ROW = HEADER_ROWS + 1;

  // Set column widths
  ws.columns = Array(18).fill({ width: 20 });

  // Add header rows
  ws.mergeCells('D1:E1');
  ws.getCell('D1').value = 'TOP PHARMA';
  ws.getCell('D1').style = boldCenteredStyle;

  ws.mergeCells('D2:E2');
  ws.getCell('D2').value = 'Inventaire au : ' + new Date().toLocaleDateString('fr-FR');
  ws.getCell('D2').style = boldCenteredStyle;

  // Add column headers
  const headers = [
    'Code article As 400',
    'Cuverie AS 400',
    'CUVE N°',
    'Ref alcool',
    'GRADUATION',
    'VOLUME',
    'Q* (TAV)',
    'T',
    'Q (TAV à 20°C)',
    'VOLUME EFFECTIF (à 20°C)',
    'VOLUME A.P',
  ];

  headers.forEach((header, index) => {
    const cell = ws.getCell(4, index + 1);
    cell.value = header;
    cell.style = boldStyle;
  });

  // Filter tanks for ALCOOL PHARMACIE group
  const pharmaTanks = tankMapping.filter(mapping => 
    mapping.groupName === 'ALCOOL PHARMACIE'
  );

  const config = {
    showAgeInMonth: false,
    showServiceDate: false
  };

  // Process tanks
  let currentRow = TANK_DATA_START_ROW;
  const tankDataPromises = pharmaTanks.map((tank, index) => {
    const tankId = Object.keys(tankDataMap).find(id => 
      String(tankDataMap[id].name) === String(tank.tankName)
    );
    if (tankId && tankDataMap[tankId]) {
      return processTankData(
        {
          tankId,
          ...tankDataMap[tankId],
          cuverieAS400: tank.cuverieAS400,
          codeArticleAS400: tank.codeArticleAS400,
          serviceDate: tank.serviceDate,
          refAlcohol: tank.refAlcohol
        },
        index,
        lastOps,
        tankDataMap,
        volumeUnit,
        currentRow,
        cellarsRef,
        config
      );
    }
    return null;
  });

  const tankData = (await Promise.all(tankDataPromises)).filter(Boolean);

  // Add tank data
  tankData.forEach((tank, index) => {
    tank.row.forEach((value, colIndex) => {
      const cell = ws.getCell(currentRow + index, colIndex + 1);
      if (typeof value === 'object' && value !== null) {
        if (value.t === 's') {
          cell.value = value.v;
        } else if (value.t === 'n' && value.f) {
          cell.value = { formula: value.f };
        }
      } else {
        cell.value = value;
      }
    });
  });

  // Add sum formulas
  const lastDataRow = currentRow + tankData.length - 1;
  const sumRow = lastDataRow + 1;
  addPharmaSumFormulas(ws, currentRow, lastDataRow, sumRow, boldStyle);

  return ws;
}; 